import React from 'react'

function About() {
    return (
        <div id="corporate">
            <div id="jobMain">
                <div class="centeredDiv">

                    <h1 class="centeredHeading">Hi I'm Ram</h1>
                    <p class="centeredPara">A Pre Final Year Computer Science Undergraduate.
                        I've worked with 2 startups as Software Developer Intern, solved 160+ questions on
                        Leetcode and Hackerrank. Participated in various hackathons, and working as a Freelance
                        Developer. I'm Actively Looking for New Opportunities. </p>


                </div>
            </div>


        </div>
    )
}

export default About